import { Button, PageHeader } from 'antd';

import TableBlock from '../../components/tables/TableBlock';
import { getCompanies } from '../../network/B2B';

const Companies = ({ _history }) => {
  return (
    <>
      <PageHeader className="site-page-header" title="Companies" />
      <TableBlock
        columns={columns}
        filters={filters}
        name={'getCompanies'}
        request={getCompanies}
        infinite
      />
    </>
  );
};

export default Companies;

const filters = (history) => ({
  fields: [
    {
      type: 'text',
      label: 'Name',
      key: 'name',
      noRegex: true,
    },
  ],
  actions: [
    {
      label: '+ Create a company',
      isActive: true,
      action: () => history.push('/companies/create'),
    },
  ],
});

const columns = (history) => [
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
  },
  {
    title: '',
    key: 'action',
    width: 25,
    render: (e) => {
      return (
        <Button
          onClick={() => history.push(`/companies/${e.id}`)}
          type="primary"
        >
          Edit
        </Button>
      );
    },
  },
];
